import { X } from "lucide-react";

import { cn } from "@/lib/utils";

export const overlayBackdropClassName = "fixed inset-0 bg-black/60 backdrop-blur-md";

export function OverlayPanel({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative w-full mx-auto overflow-hidden bg-zinc-950/95 text-white shadow-2xl backdrop-blur-xl",
        "rounded-[24px] sm:rounded-[28px] border border-white/10",
        className,
      )}
      {...props}
    />
  );
}

export function OverlayCloseButton({
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      className={cn(
        "inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/15 bg-black/55 text-white shadow-[0_10px_30px_rgba(0,0,0,0.35)] transition-colors hover:bg-black/75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950",
        className,
      )}
      aria-label="Schließen"
      {...props}
    >
      <X className="h-4 w-4" />
    </button>
  );
}